import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { EsignatureType } from '~/enums/EsignatureType';
import { ESignatureAuthenticationOptions } from '~/features/admin/ESignature/ESignatureIntegrationCard/ESignatureAuthenticationOptions';
import { UserManagementSection } from '~/features/admin/ESignature/ESignatureIntegrationCard/UserManagementSection';
import {
  EsignatureIntegrationType,
  EsignatureIntegrationWithMetadata,
  MODAL_KEYS,
} from '~/features/admin/ESignature/types';
import { slices } from '~/redux/slices';

export const EsignatureModal = () => {
  const dispatch = useDispatch();

  const action = useSelector(slices.newIntegrations.selectors.selectAction);
  const esignatureIntegration = useSelector(
    slices.newIntegrations.selectors.selectEsignatureIntegration,
  );

  const isAdobeSign = action === EsignatureType.Adobesign;

  const [integrationDraft, setIntegrationDraft] = useState<
    EsignatureIntegrationWithMetadata | undefined
  >(esignatureIntegration);

  useEffect(() => {
    setIntegrationDraft(esignatureIntegration);
  }, [esignatureIntegration]);

  if (
    action !== EsignatureType.Adobesign &&
    action !== EsignatureType.Docusign
  ) {
    return null;
  }

  const handleHide = () => {
    dispatch(slices.newIntegrations.actions.setAction(null));
    dispatch(slices.newIntegrations.actions.setEsignatureIntegration(null));
  };

  const handleAuthOptionChange = (value?: EsignatureIntegrationType) => {
    if (!integrationDraft || !value) return;

    const updatedDraft = {
      ...integrationDraft,
      integrationType: value,
    };

    setIntegrationDraft(updatedDraft);
  };

  return (
    <Modal
      isVisible
      title={isAdobeSign ? 'Adobe Sign' : 'Docusign'}
      children={
        <Layout spacing={2} direction="column">
          <ESignatureAuthenticationOptions
            providerName={integrationDraft?.name}
            //disabled={isDisabled}
            integration={integrationDraft}
            onChange={handleAuthOptionChange}
          />
          <UserManagementSection
            // disabled={isDisabled}
            //isChangeDetected={isLoading || !isUnchanged}
            authenticatedUserCount={
              esignatureIntegration?.authenticatedUserCount ?? 0
            }
            onClick={() => {
              integrationDraft?.id &&
                dispatch(
                  slices.esignature.actions.setActiveModal({
                    name: MODAL_KEYS.MANAGE,
                    integrationId: integrationDraft?.id,
                    integrationType: integrationDraft?.integrationType,
                    providerName: integrationDraft?.name ?? '',
                  }),
                );
            }}
          />
        </Layout>
      }
      onHide={handleHide}
    />
  );
};
